module.exports = __webpack_public_path__ + "img/RCT02.005ab38d.svg";